import type { Vector2 } from '@sorrem/shared';
import type { SkillTreeIntroWindow } from './skill-tree-intro';
import { useSkillTreeIntroPart } from './SkillTreeIntroPart';
import styles from './SkillTreeScene.module.scss';

interface SkillTreeIntroSweepProps {
    readonly id: string;
    readonly center: Vector2;
    /** Middle of the swept band, and its width, in the masked content's units. */
    readonly radius: number;
    readonly width: number;
    /** Where the sweep starts, in degrees clockwise from +x. */
    readonly startAngle: number;
    /** When the sweep runs on the intro's schedule. */
    readonly window: SkillTreeIntroWindow;
}

/**
 * A mask that reveals what it covers clockwise around `center`, like a
 * gauge filling, as the intro's clock passes its window, and hides it
 * counterclockwise when the clock runs back. Dials sweep to their percent
 * this way.
 */
export function SkillTreeIntroSweep({ id, center, radius, width, startAngle, window }: SkillTreeIntroSweepProps): JSX.Element {
    const ref = useSkillTreeIntroPart(window, 'sweep');
    const extent = radius + width;
    return (
        <mask id={id} maskUnits="userSpaceOnUse" x={center.x - extent} y={center.y - extent} width={extent * 2} height={extent * 2}>
            <circle
                ref={ref}
                className={styles.introSweep}
                cx={center.x}
                cy={center.y}
                r={radius}
                fill="none"
                stroke="#fff"
                strokeWidth={width}
                pathLength={100}
                transform={`rotate(${startAngle} ${center.x} ${center.y})`}
            />
        </mask>
    );
}
